<template>
  <div id="logout">
    <router-link to="/" class="nav-link" @click="logout">{{ $t("common.logout") }}</router-link>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch("clearAll")
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
